var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183,
    height: 26,
    viewBox: "0 0 189 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4102 4.23438V25.8675H38.7057V22.076H27.8905V4.23438H23.4102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2672 4.23438L79.5078 25.8675H84.2693L85.7958 21.3568L87.0468 17.5653L89.8518 9.14461L92.5715 17.5653L93.9079 21.3568L95.3049 25.8675H100.212L92.453 4.23438H87.2672Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.524 0L178.645 10.8152H181.025L181.791 8.56122L182.414 6.66547L183.819 2.45512L185.178 6.66547L185.847 8.56122L186.544 10.8152H189L185.12 0H182.524Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3468 9.14461L13.0664 17.5653H7.5417L10.3495 9.14461H10.3468ZM7.75939 4.23713L0 25.8675H4.76144L6.29072 21.3568H14.4028L15.7998 25.8675H20.7073L12.9452 4.23438H7.75663L7.75939 4.23713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.241 4.23438H51.0284C53.1832 4.23438 54.8337 4.86538 55.98 6.13013C57.1373 7.38387 57.7132 9.00684 57.7132 10.9935C57.7132 13.14 57.0822 14.8594 55.8174 16.1518C54.5637 17.4441 52.9187 18.0916 50.8796 18.0916H45.7214V25.8648H41.2383V4.23438H41.241ZM45.7242 8.02589V14.3001H49.8546C52.059 14.3001 53.1612 13.2227 53.1612 11.0679C53.1612 9.90236 52.8388 9.10328 52.1912 8.67343C51.5437 8.24357 50.56 8.02589 49.2374 8.02589H45.7242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8047 4.23438H64.2878V12.3768H72.7361V4.23438H77.2192V25.8675H72.7361V16.1683H64.2878V25.8675H59.8047V4.23438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.855 25.8675V4.23438H113.538C115.528 4.23438 117.143 4.73311 118.388 5.73335C119.642 6.72256 120.27 8.11407 120.27 9.90787C120.27 11.9855 119.383 13.4101 117.611 14.1844C119.854 15.0854 120.975 16.791 120.975 19.2985C120.829 21.4918 120.099 23.1396 118.785 24.2363C117.473 25.3247 115.252 25.8675 112.128 25.8675H102.855ZM107.339 12.6716H112.703C114.85 12.6716 115.922 11.8643 115.922 10.2468C115.922 8.76711 114.806 8.02865 112.571 8.02865H107.339V12.6716ZM107.339 22.076H112.996C115.327 22.076 116.492 21.0537 116.492 19.0037C116.492 17.1906 115.396 16.284 113.199 16.284H107.336V22.0732L107.339 22.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.486 25.8675V4.23438H139.49V8.02589H127.969V12.611H138.578V16.4025H127.969V22.076H139.975V25.8675H123.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.551 4.23438H160.2V8.02589H153.614V25.8675H149.134V8.02589H142.551V4.23438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.203 25.8687L167.963 4.23828H173.151L180.91 25.8687H176.003L174.606 21.358H166.494L164.965 25.8687H160.203ZM167.742 17.5665H173.267L170.547 9.14576L167.739 17.5665H167.742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_1389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 25.8683,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c0c8e3364ede3e458a824cece84aca06.svg";
export { ForwardRef as ReactComponent };